import React from 'react';
import '../styles/Expertise.css';

import File from './File.jsx';

import logo_assembly from '../assets/expertise/assembly.png';
import logo_bash from '../assets/expertise/bash.png';
import logo_c from '../assets/expertise/c.png';
import logo_css from '../assets/expertise/css.png';
import logo_docker from '../assets/expertise/docker.png';
import logo_fastapi from '../assets/expertise/fastapi.png';
import logo_figma from '../assets/expertise/figma.png';
import logo_git from '../assets/expertise/git.png';
import logo_html from '../assets/expertise/html.png';
import logo_java from '../assets/expertise/java.png';
import logo_javascript from '../assets/expertise/javascript.png';
import logo_jira from '../assets/expertise/jira.png';
import logo_nodejs from '../assets/expertise/nodejs.png';
import logo_python from '../assets/expertise/python.png';
import logo_react from '../assets/expertise/react.png';
import logo_sql from '../assets/expertise/sql.png';
import logo_typescript from '../assets/expertise/typescript.png';


const Expertise = ({ isDarkMode }) => {
    const infoClass = `expertise-content-info ${
        isDarkMode ? 'expertise-content-info-dark' : 'expertise-content-info-light'
    }`;

    const dividerClass = `expertise-division ${
        isDarkMode ? 'expertise-division-dark' : 'expertise-division-light'
    }`;

    return (
        <div className='expertise-container'>
            {/* Information section of expertise */}
            <div className={infoClass}>
                <div className="expertise-heading">
                    <h1>
                        Expertise 🔧
                    </h1>
                </div>

                <div className={dividerClass} />

                <div className="expertise-content">
                    <p>
                    I have honed a diverse set of technical and design skills through hands-on experience in <span>front-end</span> and <span>back-end</span> development.
                    <br /> <br />
                    These skills span across various <span>programming languages</span>, <span>frameworks</span>, and <span>tools</span> that allow me top complete user-friendly applications from concept to deployment. 🚀✨
                    </p>
                </div>
            </div>

            {/* Logos/file of languages, frameworks, and tools */}
            <div className='expertise-content-files'>
                <div className={`expertise-files-container ${isDarkMode ? 'expertise-files-container-dark' : 'expertise-files-container-light'}`}>
                    <div className='expertise-heading-container'>
                        <div className="expertise-files-heading">Programming Languages</div>    
                    </div>
                    
                    <div className='expertise-files'>
                        <File name='TypeScript' image={logo_typescript} isDarkMode={isDarkMode} />
                        <File name='JavaScript' image={logo_javascript} isDarkMode={isDarkMode}/>
                        <File name='HTML' image={logo_html} isDarkMode={isDarkMode}/>
                        <File name='CSS' image={logo_css} isDarkMode={isDarkMode}/>
                        <File name='Python' image={logo_python} isDarkMode={isDarkMode}/>
                        <File name='Java' image={logo_java} isDarkMode={isDarkMode}/>
                        <File name='PostgreSQL' image={logo_sql} isDarkMode={isDarkMode}/>
                        <File name='C' image={logo_c} isDarkMode={isDarkMode}/>
                        <File name='Bash' image={logo_bash} isDarkMode={isDarkMode}/>
                        <File name='Assembly' image={logo_assembly} isDarkMode={isDarkMode}/>
                    </div>
                </div>

                <div className={`expertise-files-container ${isDarkMode ? 'expertise-files-container-dark' : 'expertise-files-container-light'}`}>
                    <div className='expertise-heading-container'>
                        <div className="expertise-files-heading">Frameworks</div>    
                    </div>
                    
                    <div className='expertise-files'>
                        <File name='React' image={logo_react} isDarkMode={isDarkMode}/>
                        <File name='Node.js' image={logo_nodejs} isDarkMode={isDarkMode}/>
                        <File name='FastAPI' image={logo_fastapi} isDarkMode={isDarkMode}/>
                    </div>
                </div>

                <div className={`expertise-files-container ${isDarkMode ? 'expertise-files-container-dark' : 'expertise-files-container-light'}`}>
                    <div className='expertise-heading-container'>
                        <div className="expertise-files-heading">Tools & Platforms</div>   
                    </div>
                    
                    <div className='expertise-files'>
                        <File name='Docker' image={logo_docker} isDarkMode={isDarkMode}/>
                        <File name='Git' image={logo_git} isDarkMode={isDarkMode}/>
                        <File name='Jira' image={logo_jira} isDarkMode={isDarkMode}/>
                        <File name='Figma' image={logo_figma} isDarkMode={isDarkMode}/>
                    </div>
                </div>

            </div>
            <div className={`expertise-credits ${isDarkMode ? 'expertise-credits-dark' : 'expertise-credits-light'}`}><p>Icons by <a href="https://icons8.com" target="_blank" rel="noopener noreferrer">Icons8</a>.</p></div>
        </div>
    );
};

export default Expertise;
